import React, { Component } from 'react'
import Axios from 'axios'
import { CARRIER_RESTRICTION_ACCOUNT,CARRIER_RESTRICTION_ACCOUNT_UPDATE, LOGIN_URL } from '../../../config/rest_endpoints'
import { getUser } from '../../../actions/session'
import CustomLoader from '../../common/loader';
import { Notifications } from '../../common/notification';
import { Redirect } from 'react-router-dom';

class CarrierRestriction extends Component {
    constructor(props) {
        super(props)
        this.state = {
            User: getUser(),
            data: [],
            userId: this.props.userId,
            active: false,
            isGetting:false,
            updatePayload:null,
            isDisable:true,
            isLoginURL: false,
            limitErrors: {},
            trafficFilter: 'all'
        }

        this.toggleSwitch = this.toggleSwitch.bind(this)
        this.getCallRestric = this.getCallRestric.bind(this)
        this.updateCarrier = this.updateCarrier.bind(this)
        this.handleLimitChange = this.handleLimitChange.bind(this)
    }

    componentDidMount() {
        this.getCallRestric()
    }

    getCallRestric() {
        const { User, userId } = this.state
        var headers = { 'Authorization': "Bearer " + User.token }
        this.setState({isGetting:true})
        Axios.get(`${CARRIER_RESTRICTION_ACCOUNT}/${userId}/carrier`, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                var resp = (res.data.data || []).map(item => ({
                    ...item,
                    sessions: this.normalizeLimitFromApi(item.sessions),
                    cps: this.normalizeLimitFromApi(item.cps),
                    maxSessions: this.normalizeMaxLimit(item.maxSessions),
                    maxCps: this.normalizeMaxLimit(item.maxCps),
                    stirShakenLevel: this.normalizeStirShakenLevel(item.stirShakenLevel),
                }))
                this.setState({
                    data: resp,
                    isGetting:false,
                })
            }
        }).catch(err => {
            const alert = err.response
            console.log(`alert.data.message`, alert.data.message)
            if (alert.data.message === 'invalid or expired jwt') {
                localStorage.removeItem('user');
                this.setState({ isLoginURL: true })
                Notifications.notify(alert.data.message, "Token Expire", "error")
            }
            Notifications.notify(alert.data.message, "Failed", "error")
            this.setState({
                isGetting: false
            })
        })
    }

    toggleSwitch(obj,id) {
        const {data,User,userId,limitErrors} = this.state
        console.log(`obj`, obj)
        let update = {
            ...obj,
            active:!obj.active,
        }
        console.log(`update`, update)
        data.splice(id, 1, update);
        var payload = {
            "data":data
        }
        console.log(`payload`, payload)
        const nextLimitErrors = {...limitErrors}
        delete nextLimitErrors[this.limitErrorKey(id, 'sessions')]
        delete nextLimitErrors[this.limitErrorKey(id, 'cps')]
        this.setState({updatePayload:payload, isDisable:false, limitErrors: nextLimitErrors})
        var headers = { 'Authorization': "Bearer " + User.token }
        Axios.post(`${CARRIER_RESTRICTION_ACCOUNT}/${userId}/carrier`,payload, { headers }).then(res => {
            if (res) {
                console.log('res :>> ', res);
                // this.getCallRestric()
            }
        }).catch(err => {
            const alert = err.response
            Notifications.notify(alert.data.message, "Failed", "error")

        })
    }

    handleLimitChange(id, field, value) {
        const { data, limitErrors } = this.state
        const errorKey = this.limitErrorKey(id, field)
        const row = data[id]
        const maxValue = this.getMaxForField(row, field)
        const isInvalidValue = value !== '' && (!/^\d+$/.test(value) || value === '0' || /^0\d+/.test(value))

        if (isInvalidValue) {
            this.setState({
                limitErrors: {
                    ...limitErrors,
                    [errorKey]: 'Min 1'
                }
            })
            return
        }

        const parsedValue = value === '' ? null : parseInt(value, 10)
        if (parsedValue !== null && maxValue !== null && parsedValue > maxValue) {
            this.setState({
                limitErrors: {
                    ...limitErrors,
                    [errorKey]: `Max ${this.formatLimit(maxValue)}`
                }
            })
            return
        }

        const nextData = data.map((row, idx) => {
            if (idx !== id) {
                return row
            }
            return {
                ...row,
                [field]: parsedValue
            }
        })
        const nextLimitErrors = {...limitErrors}
        delete nextLimitErrors[errorKey]
        this.setState({
            data: nextData,
            updatePayload: { data: nextData },
            isDisable: false,
            limitErrors: nextLimitErrors
        })
    }

    handleStirShakenChange(id, value) {
        const { data } = this.state
        const nextData = data.map((row, idx) => {
            if (idx !== id) {
                return row
            }
            return {
                ...row,
                stirShakenLevel: this.normalizeStirShakenLevel(value)
            }
        })
        this.setState({
            data: nextData,
            updatePayload: { data: nextData },
            isDisable: false
        })
    }

    limitErrorKey(id, field) {
        return `${id}-${field}`
    }

    hasLimitErrors() {
        return Object.keys(this.state.limitErrors).length > 0
    }

    normalizeLimitFromApi(value) {
        return value === undefined || value === null || value === 0 || value === '0' ? null : value
    }

    normalizeMaxLimit(value) {
        if (value === undefined || value === null || value === 0 || value === '0') {
            return null
        }
        const parsedValue = parseInt(value, 10)
        return Number.isNaN(parsedValue) || parsedValue < 1 ? null : parsedValue
    }

    normalizeStirShakenLevel(value) {
        return ['A', 'AB', 'ABC', 'NONE'].indexOf(value) !== -1 ? value : 'ABC'
    }

    getLimitDisplayValue(value) {
        return value === null || value === undefined || value === 0 || value === '0' ? '' : value
    }

    getMaxForField(row, field) {
        if (!row) {
            return null
        }
        return field === 'sessions' ? row.maxSessions : row.maxCps
    }

    formatLimit(value) {
        return value === null || value === undefined ? 'No max' : value.toLocaleString()
    }

    renderLimitHint(error, maxValue) {
        const hintStyle = error ? {
            marginTop:'4px',
            fontSize:'11px',
            lineHeight:'1',
            fontWeight:'600',
            color:'#B91C1C'
        } : {
            marginTop:'4px',
            fontSize:'11px',
            lineHeight:'1',
            fontWeight:'600',
            color:'#64748B'
        }

        return <div style={hintStyle}>{error || (maxValue === null ? 'No max' : `Max ${this.formatLimit(maxValue)}`)}</div>
    }

    getFilteredCarrierRows() {
        const { data, trafficFilter } = this.state
        if (!Array.isArray(data)) {
            return []
        }
        return data
            .map((row, index) => ({ row, index }))
            .filter(({ row }) => {
                if (trafficFilter === 'enabled') {
                    return row.active !== false
                }
                if (trafficFilter === 'disabled') {
                    return row.active === false
                }
                return true
            })
    }

    handleTrafficFilterChange(value) {
        this.setState({ trafficFilter: value })
    }

    renderCallRestriction() {
        const { data } = this.state
        var nullData = (
            <tr>
                <td colSpan="6" style={{padding:'14px 16px',fontSize:'13px',color:'#64748B',textAlign:'center'}}>Showing 0 of 0 entries</td>
            </tr>
        )
        if (data === null) {
            return nullData
        }
        if (data.length === 0) {
            return nullData
        }
        const filteredRows = this.getFilteredCarrierRows()
        if (filteredRows.length === 0) {
            return (
                <tr>
                    <td colSpan="6" style={{padding:'14px 16px',fontSize:'13px',color:'#64748B',textAlign:'center'}}>No carriers match this filter</td>
                </tr>
            )
        }
        else {
            return filteredRows.map(({ row, index }) => {
                const idx = index
                console.log(`row`, row)
                const badgeStyle = row.active === false ? {
                    display:'inline-flex',
                    alignItems:'center',
                    justifyContent:'center',
                    minWidth:'86px',
                    padding:'5px 9px',
                    borderRadius:'4px',
                    fontSize:'12px',
                    fontWeight:'700',
                    lineHeight:'1',
                    background:'#FEE2E2',
                    color:'#991B1B'
                } : {
                    display:'inline-flex',
                    alignItems:'center',
                    justifyContent:'center',
                    minWidth:'86px',
                    padding:'5px 9px',
                    borderRadius:'4px',
                    fontSize:'12px',
                    fontWeight:'700',
                    lineHeight:'1',
                    background:'#DCFCE7',
                    color:'#166534'
                }
                const limitInputStyle = {
                    width:'88px',
                    maxWidth:'100%',
                    height:'30px',
                    margin:'0 auto',
                    textAlign:'center',
                    padding:'4px 8px',
                    fontSize:'13px'
                }
                const limitErrorStyle = {
                    ...limitInputStyle,
                    border:'1px solid #DC2626',
                    boxShadow:'0 0 0 2px rgba(220, 38, 38, 0.12)',
                    background:'#FEF2F2'
                }
                const sessionsError = this.state.limitErrors[this.limitErrorKey(idx, 'sessions')]
                const cpsError = this.state.limitErrors[this.limitErrorKey(idx, 'cps')]
                const maxSessions = this.getMaxForField(row, 'sessions')
                const maxCps = this.getMaxForField(row, 'cps')
                const stirShakenSelectStyle = {
                    width:'112px',
                    maxWidth:'100%',
                    height:'30px',
                    margin:'0 auto',
                    textAlign:'center',
                    padding:'3px 8px',
                    fontSize:'13px'
                }
                return (
                    <tr key={idx}>
                        <td style={{textAlign:'left',padding:'8px 14px',fontSize:'13px',verticalAlign:'middle'}}>{row.accountName}</td>
                        <td style={{textAlign:'center',padding:'8px 10px',verticalAlign:'middle'}}><span style={badgeStyle}>{row.active === false ? 'Not Allowed' : 'Allowed'}</span></td>
                        <td style={{textAlign:'center',padding:'7px 8px',verticalAlign:'middle'}}>
                            <div style={{display:'inline-block'}}>
                                <input
                                    className="form-control form-control-sm"
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    min="1"
                                    disabled={!row.active}
                                    style={sessionsError ? limitErrorStyle : limitInputStyle}
                                    value={this.getLimitDisplayValue(row.sessions)}
                                    onChange={(event) => this.handleLimitChange(idx, 'sessions', event.target.value)}
                                />
                                {this.renderLimitHint(sessionsError, maxSessions)}
                            </div>
                        </td>
                        <td style={{textAlign:'center',padding:'7px 8px',verticalAlign:'middle'}}>
                            <div style={{display:'inline-block'}}>
                                <input
                                    className="form-control form-control-sm"
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    min="1"
                                    disabled={!row.active}
                                    style={cpsError ? limitErrorStyle : limitInputStyle}
                                    value={this.getLimitDisplayValue(row.cps)}
                                    onChange={(event) => this.handleLimitChange(idx, 'cps', event.target.value)}
                                />
                                {this.renderLimitHint(cpsError, maxCps)}
                            </div>
                        </td>
                        <td style={{textAlign:'center',padding:'7px 8px',verticalAlign:'middle'}}>
                            <select
                                className="form-control form-control-sm"
                                disabled={!row.active}
                                style={stirShakenSelectStyle}
                                value={this.normalizeStirShakenLevel(row.stirShakenLevel)}
                                onChange={(event) => this.handleStirShakenChange(idx, event.target.value)}
                            >
                                <option value="A">A</option>
                                <option value="AB">A, B</option>
                                <option value="ABC">A, B, C</option>
                                <option value="NONE">No STIR/SHAKEN Check</option>
                            </select>
                        </td>
                        {/* <td><span className="size-1"><Switch height={20} width={50} onChange={this.toggleSwitch.bind(this, row,idx)} checked={row.active} /></span></td> */}
                        <td style={{textAlign:'center',padding:'8px 8px',verticalAlign:'middle'}}><input className='myCheck' style={{display:'block',margin:'0 auto'}} type="checkbox"  onChange={this.toggleSwitch.bind(this, row,idx)}  checked={row.active} /></td>
                    </tr>
                )
            })
        }
    }

    updateCarrier() {
        const {updatePayload,User,userId,data} = this.state
        console.log('updatePayload :>> ', updatePayload);
        this.setState({isGetting:true})
        var headers = { 'Authorization': "Bearer " + User.token }
        var payload = {
            "data":data
        }
        if(updatePayload === null) {
           
            this.setState({updatePayload:payload,isGetting:false})
        }
        else {
            Axios.post(`${CARRIER_RESTRICTION_ACCOUNT_UPDATE}/${userId}/carrier`,updatePayload, { headers }).then(res => {
                if (res) {
                    this.getCallRestric()
                    this.setState({isGetting:false, isDisable:true})
                    console.log('res :>> ', res);
                }
            }).catch(err => {
                const alert = err.response
                console.log(`alert.data.message`, alert.data.message)
                if (alert.data.message === 'invalid or expired jwt') {
                    localStorage.removeItem('user');
                    this.setState({ isLoginURL: true })
                    Notifications.notify(alert.data.message, "Token Expire", "error")
                }
                Notifications.notify(alert.data.message, "Failed", "error")
                this.setState({
                    isGetting: false
                })
            })
        }
       
    }

    render() {
        if (this.state.isLoginURL === true) {
            return <Redirect to={LOGIN_URL} ></Redirect>
        }
        const filterButtonStyle = {
            border:'1px solid #CBD5E1',
            background:'#FFFFFF',
            color:'#334155',
            padding:'5px 12px',
            fontSize:'12px',
            fontWeight:'700',
            lineHeight:'1.2',
            minWidth:'74px'
        }
        const activeFilterButtonStyle = {
            ...filterButtonStyle,
            background:'#0F766E',
            borderColor:'#0F766E',
            color:'#FFFFFF'
        }
        return (
            <div style={{border:'none',borderRadius:'5px',boxShadow:'0 0 20px rgba(0,0,0,.08)',padding:'14px 16px',marginTop:'8px',width:'100%'}} className="card">
                <div style={{width:'100%'}}>
                    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',gap:'12px',marginBottom:'10px',flexWrap:'wrap'}}>
                        <div style={{display:'inline-flex',alignItems:'center',gap:'0'}}>
                            <button
                                type="button"
                                style={this.state.trafficFilter === 'all' ? activeFilterButtonStyle : filterButtonStyle}
                                onClick={() => this.handleTrafficFilterChange('all')}
                            >All</button>
                            <button
                                type="button"
                                style={this.state.trafficFilter === 'enabled' ? activeFilterButtonStyle : filterButtonStyle}
                                onClick={() => this.handleTrafficFilterChange('enabled')}
                            >Enabled</button>
                            <button
                                type="button"
                                style={this.state.trafficFilter === 'disabled' ? activeFilterButtonStyle : filterButtonStyle}
                                onClick={() => this.handleTrafficFilterChange('disabled')}
                            >Disabled</button>
                        </div>
                        <button type="submit" className="main-button btn btn-success btn-sm" disabled={this.state.isDisable || this.hasLimitErrors() ? true : false} onClick={this.updateCarrier} >Update Carrier <i className="icon-database-insert ml-2"></i></button>
                    </div>
                    <div id="DataTables_Table_0_wrapper" className="dataTables_wrapper no-footer" style={{width:'100%',overflowX:'hidden'}}>
                        <div className="datatable-scroll" style={{ width:'100%',overflowX: 'auto' }}>
                            <table style={{border:'1px solid #E2E8F0',borderCollapse:'collapse',tableLayout:'fixed',width:'100%',marginBottom:0}} className="table table-striped no-footer" id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info">
                                <colgroup>
                                    <col style={{width:'36%'}} />
                                    <col style={{width:'14%'}} />
                                    <col style={{width:'14%'}} />
                                    <col style={{width:'14%'}} />
                                    <col style={{width:'14%'}} />
                                    <col style={{width:'8%'}} />
                                </colgroup>
                                <thead>
                                    <tr className="stickeyHeader">
                                        <th style={{color:'#0F172A',borderBottom:'1px solid #CBD5E1',fontSize:'13px',fontWeight:'700',textAlign:'left',padding:'9px 14px'}}>Name</th>
                                        <th style={{color:'#0F172A',borderBottom:'1px solid #CBD5E1',fontSize:'13px',fontWeight:'700',textAlign:'center',padding:'9px 10px'}}>Traffic</th>
                                        <th style={{color:'#0F172A',borderBottom:'1px solid #CBD5E1',fontSize:'13px',fontWeight:'700',textAlign:'center',padding:'9px 8px'}}>Sessions</th>
                                        <th style={{color:'#0F172A',borderBottom:'1px solid #CBD5E1',fontSize:'13px',fontWeight:'700',textAlign:'center',padding:'9px 8px'}}>CPS</th>
                                        <th style={{color:'#0F172A',borderBottom:'1px solid #CBD5E1',fontSize:'13px',fontWeight:'700',textAlign:'center',padding:'9px 8px'}}>Stir/Shaken</th>
                                        <th style={{color:'#0F172A',borderBottom:'1px solid #CBD5E1',fontSize:'13px',fontWeight:'700',textAlign:'center',padding:'9px 8px'}}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.isGetting ? (
                                        <tr>
                                            <td colSpan="6" style={{padding:'18px',textAlign:'center'}}><CustomLoader /></td>
                                        </tr>
                                    ) : this.renderCallRestriction()}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default CarrierRestriction
